<template>
  <a-spin tip="数据加载中..." :spinning="spinning">
    <div class="details-info">
      <div class="ht-content" v-html="info.content">
      </div>
      <div class="right-info">
        <div class="right-row">
          <div class="right-title">发布机关：</div>
          <div class="right-value">{{ info.organ }}</div>
          <div style="clear: both"></div>
        </div>
        <div class="right-row">
          <div class="right-title">发布年份：</div>
          <div class="right-value">{{ info.year }}年</div>
          <div style="clear: both"></div>
        </div>
        <div class="right-row">
          <div class="right-title">发布编号：</div>
          <div class="right-value">{{ info.number }}</div>
          <div style="clear: both"></div>
        </div>
        <div class="right-row">
          <div class="right-title">发布通知：</div>
          <div class="right-value" style="overflow-wrap: break-word">
            {{ this.tz }}
            <a @click="zk" class="a-btn" v-if="this.zkStats">展开</a>
            <a @click="sq" class="a-btn" v-if="this.sqStats">收起</a>
          </div>
          <div style="clear: both"></div>
        </div>
        <a-divider type="horizontal" :dashed="false"/>
        <div style="padding-right: 10px;word-break: break-all;height: auto" v-html="info.tips"></div>
      </div>
      <div style="clear: both"></div>
    </div>
  </a-spin>
</template>

<script>
import {getAction} from "@/api/manage";

export default {
  name: "ContractDetails",
  data() {
    return {
      info: {},
      tz: '',
      oldContent: '',
      zkStats: false,
      sqStats: false,
      spinning:false,
    }
  },
  created() {
    this.getDetails(this.$route.params.id)
  },
  methods: {
    zk() {
      this.tz = this.oldContent;
      this.zkStats = false;
      this.sqStats = true;
    },
    sq() {
      this.tz = this.oldContent.substr(0, 40) + '...';
      this.zkStats = true;
      this.sqStats = false;
    },
    getDetails(id) {
      this.spinning=true;
      getAction('/contract/details', {contractId: id}).then(res => {
        if (res.success) {
          this.info = res.data;
          this.oldContent = res.data.notice
          if (res.data.notice.length > 40) {
            this.tz = res.data.notice.substr(0, 40) + '...';
            this.zkStats = true;
          } else {
            this.tz = res.data.notice
          }
          this.spinning=false;
        }
      })
    }
  }
}
</script>

<style scoped>
.details-info {
  width: 1200px;
  margin: 20px auto 50px auto;
  background: #FFFFFF;
  height: auto;
  min-height: calc(100vh - 100px);
}

.ht-content {
  width: 900px;
  padding: 50px 30px;
  border-right: #E5E5E5 solid 1px;
  word-break: break-all;
  float: left;
}

.ht-content >>> table {
  border: 1px solid #212529;
  width: 850px;
}

.ht-content >>> table td {
  border: 1px solid #212529;
}

.right-info {
  /*border: #888888 solid 1px;*/
  width: 25%;
  height: 1500px;
  padding-left: 20px;
  margin-top: 50px;
  float: left;
  height: auto;
}

.right-title {
  float: left;
}

.right-value {
  width: 210px;
  padding-right: 5px;
  float: right;
  text-overflow: ellipsis;
}

.a-btn {
  color: #333333;
  font-weight: bold;
}

.right-row {
  margin-bottom: 5px;
}
</style>
